import React, { forwardRef } from 'react';

import { Checkbox } from 'primereact/checkbox';
import { classNames } from 'primereact/utils';
import { GroupedAddon } from './GroupedAddon';

export const GroupTitledCheckbox = forwardRef((props, ref) => {
  const {
    name,
    title = '',
    value,
    items = [],
    onChange,
    error,
    readOnly = false,
    classNameProps,
    variant,
  } = props;

  return (
    <>
      <div className="p-inputgroup h-full">
        <GroupedAddon
          title={title}
          variant={variant}
          classNameProps={classNameProps}
        />
        <div
          className={classNames(
            'cm-grouped-body p-inputgroup-addon bg-transparent'
          )}
        >
          {items.map((item, idx) => (
            <div key={`${name}_${idx}`}>
              <div className="flex flex-auto align-items-center justify-content-start gap-1">
                <Checkbox
                  inputRef={ref}
                  inputId={`tc_${props.id || name}_${idx}`}
                  name={name}
                  value={item.value}
                  onChange={(e) => onChange(e.value)}
                  checked={value === item.value}
                  readOnly={readOnly}
                />
                <label
                  className={item.labelColor}
                  htmlFor={`tc_${props.id || name}_${idx}`}
                >
                  {item.label}
                </label>
              </div>
            </div>
          ))}
        </div>
      </div>
      {error && <small className="p-error">{error?.message}</small>}
    </>
  );
});

GroupTitledCheckbox.displayName = 'GroupTitledCheckbox';
